import { AfterViewInit, Component, DestroyRef, ElementRef, Input, OnInit, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ScrollAdapterComponent } from '@frontend/sports/common/core/feature/scroll-adapter';
import { CssSupportService } from '@frontend/sports/common/core/utils/css-support';
import { NOT_APPLICABLE, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { MarketingViewModel } from '@frontend/sports/types/components/marketing';
import { DeviceService } from '@frontend/vanilla/core';

import { ColumnLayoutService } from '../../../layout/column-layout.service';

@Component({
    selector: 'ms-racing-promo-banner',
    templateUrl: './racing-promo-banner.html',
    standalone: false,
})
export class RacingPromoBannerComponent implements OnInit, AfterViewInit {
    @Input() banners: MarketingViewModel[];
    @ViewChild(ScrollAdapterComponent) scrollAdapter?: ScrollAdapterComponent;
    isMobile: boolean;

    private readonly destroyRef = inject(DestroyRef);

    constructor(
        protected columnLayoutService: ColumnLayoutService,
        protected elementRef: ElementRef,
        protected cssSupportService: CssSupportService,
        protected deviceService: DeviceService,
        private trackingService: TrackingService,
    ) {}

    ngOnInit(): void {
        this.isMobile = this.deviceService.isMobile;
        this.trackingService.track(trackingConstants.EVENT_CONTENT_VIEW, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'greyhounds-banner',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'greyhounds-banner',
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'load',
            [trackingConstants.COMPONENT_EVENT_DETAILS]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_POSITION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: 'greyhounds-racing',
        });
    }

    trackBannerClicked(teaser: MarketingViewModel, index: number) {
        this.trackingService.track(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'greyhounds-banner',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'greyhounds-banner',
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'Click',
            [trackingConstants.COMPONENT_POSITION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_CONTENT_POSITION]: index,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: 'teaser',
            [trackingConstants.COMPONENT_URL_CLICKED]: teaser.href,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: 'greyhounds-racing',
        });
    }

    ngAfterViewInit(): void {
        this.columnLayoutService.rightColumnSizeChanged.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            if (this.scrollAdapter) {
                this.scrollAdapter.setArrows();
            }
        });

        const scrollElement: HTMLElement | null = this.elementRef.nativeElement.querySelector('ms-scroll-adapter');
        if (!scrollElement || !this.cssSupportService.isTouchActionSupported()) {
            return;
        }
    }
}
